import { render, staticRenderFns } from "./item-produto.vue?vue&type=template&id=0b98421e&"
import script from "./item-produto.vue?vue&type=script&lang=js&"
export * from "./item-produto.vue?vue&type=script&lang=js&"
import style0 from "./item-produto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports